
/**
 * 플랜 상태
 */
export type GetPlanChangeOptions200DowngradeOptionsItemStatus = typeof GetPlanChangeOptions200DowngradeOptionsItemStatus[keyof typeof GetPlanChangeOptions200DowngradeOptionsItemStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPlanChangeOptions200DowngradeOptionsItemStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
} as const;
